import React, { Component } from "react";
// import EligibilityCheck from "./EligibilityCheck";
import ClaimsTable from "./ClaimsTable";
// import MemberDetail from "../memberSearch/memberDetails";
import ClaimsDetail from "./claimDetails/ClaimDetailsHome";
import { addClaimsTab } from "./../../store/broadcaster/BroadcastRegister";
import { Tabs } from "antd";
import Config from "../../config";

const { TabPane } = Tabs;
const fromWhere = "Claims Search";

export default class ClaimsSearchDashboard extends Component {
  subscribe;
  constructor(props) {
    super(props);
    this.state = {
      TabButtons: null,
      newTabIndex: 0,
      activeKey: "1",
      panes: [],
      fromPage: this.props.hereFrom
    };
    this.subscribe = addClaimsTab.subscribe((tabInfo) => {
      if (tabInfo === null) return;
      else {
        if (tabInfo.type === "claims") this.add(tabInfo);
        else return
      }
    });
  }

  componentDidMount() {
    if(sessionStorage.getItem("planName") === 'solis' && this.state.fromPage === 'sidebar'){
      var windowDimensions = "height="+window.screen.height+",width="+window.screen.width
      this.setState({
        TabButtons:
        <div className="tab-button-container">
          <button onClick={() => {
            window.open(
              Config.OTC,
              "OTC Portal",
              windowDimensions
            );
          }}>OTC Portal</button>
          <button onClick={() => {
            window.open(
              Config.CalypsoLite,
              "Calypso Lite",
              windowDimensions
            );
          }}>Calypso Lyte</button>
          <button onClick={() => {
            window.open(
              Config.EnsureDataSolutions,
              "Ensure Data Solutions",
              windowDimensions
            );
          }}>Ensure Data Solutions</button>
          <button onClick={() => {
            window.open(
              Config.SolisHealthPlan,
              "Solis Health Plan",
              windowDimensions
            );
          }}>Solis Health Plans</button>
        </div>        
      });
    }
    this.setState({
      panes: [{
        title: "Claims Search",
        content: <ClaimsTable fromPage={this.props.fromPage} claimsData={this.props.claimsdata} fetchedTotalRecords={this.props.fetchedTotalRecords} MemberId={this.props.memberid} />,
        key: "1",
        closable: false,
      },]
    })
  }

  onChange = (activeKey) => {
    this.setState({ activeKey });
  };

  onEdit = (targetKey, action) => {
    this[action](targetKey);
  };

  add = (tabDetails) => {
    if (tabDetails.item != undefined) {
      const { panes } = this.state;
      let activeKey;
      const currentIndex = panes.findIndex((pane) =>
        pane.title.includes(tabDetails.item.claimNumber)
      );
      if (currentIndex === -1) {
        activeKey = `newTab${++this.state.newTabIndex}`;
        switch (tabDetails.type) {
          case "claims":
            panes.push({
              title: "Claim No: " + tabDetails.item.claimNumber,
              content: (
                <ClaimsDetail data={tabDetails.item} fromPage={fromWhere} />
              ),
              key: activeKey,
            });
            break;
        }
      } else {
        activeKey = panes[currentIndex].key;
      }
      this.setState({ panes, activeKey });
    }
  };

  remove = (targetKey) => {
    const { panes, activeKey } = this.state;
    let newActiveKey = activeKey;
    let lastIndex;
    panes.forEach((pane, i) => {
      if (pane.key === targetKey) {
        lastIndex = i - 1;
      }
    });
    const newPanes = panes.filter((pane) => pane.key !== targetKey);
    if (newPanes.length && newActiveKey === targetKey) {
      if (lastIndex > 0) {
        newActiveKey = newPanes[lastIndex].key;
      } else {
        newActiveKey = newPanes[0].key;
      }
    }
    this.setState({
      panes: newPanes,
      activeKey: newActiveKey,
    });
  };

  render() {
    return (
      <Tabs
        tabBarExtraContent= {this.state.TabButtons}
        onChange={this.onChange}
        activeKey={this.state.activeKey}
        type="editable-card"
        onEdit={this.onEdit}
      // style={{ position: "" }}
      >
        {this.state.panes.map((pane) => (
          <TabPane tab={pane.title} key={pane.key} closable={pane.closable}>
            {pane.content}
          </TabPane>
        ))}
      </Tabs>
    );
  }
}
